// ====== OFFERLY OFFERS TRACKING ======

(function initOfferlyTracking() {
  function getCurrency(fallback = "EUR") {
    try {
      if (typeof Shopify !== 'undefined' && Shopify.currency?.active) {
        return Shopify.currency.active;
      }
      return document.querySelector('meta[property="og:price:currency"]')?.content || fallback;
    } catch (e) {
      return fallback;
    }
  }

  if (typeof pushEvent !== 'function') {
    window.pushEvent = function(eventName, data = {}) {
      const eventData = {
        event: eventName,
        ecommerce: data.ecommerce || null,
        ...data
      };

      if (eventData.ecommerce?.items?.length === 0) {
        console.warn(`⚠️ Event "${eventName}" skipped – no items to send.`);
        return;
      }

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(eventData);
      console.log(`📊 Event sent: ${eventName}`, eventData);
    };
  }

  let isTracking = false;
  let modalWasOpen = false;

  setInterval(() => {
    const modal = document.getElementById('OfferlyModalDiv');
    const isOpen = modal && modal.style.display === 'flex';

    if (isOpen && !modalWasOpen) {
      console.log('📥 Offer modal opened');
      modalWasOpen = true;

      // Publish modal open event to Shopify analytics (received by Custom Pixel)
      if (window.Shopify?.analytics?.publish) {
        window.Shopify.analytics.publish('view_offer_form', {
          page_location: window.location.href
        });
        console.log('📤 view_offer_form published → Custom Pixel');
      }
    }

    if (!isOpen && modalWasOpen) {
      modalWasOpen = false;
      isTracking = false;
    }

    if (isOpen && !isTracking) {
      const btn = document.getElementById('submitOfferButton');
      if (btn) {
        isTracking = true;

        btn.addEventListener('click', function() {
          const modalContent = document.querySelector('.offerly-modal-content');
          const name = modalContent?.querySelector('input[name="customerName"]')?.value?.trim() || '';
          const email = modalContent?.querySelector('input[name="customerEmail"]')?.value?.trim() || '';
          const offerAmount = parseFloat(modalContent?.querySelector('input[name="offerAmount"]')?.value?.replace(',', '.') || 0);

          if (!name || !email || !offerAmount || !email.includes('@')) {
            return;
          }

          const productTitle = document.querySelector('#modalProductTitle')?.innerText?.trim() || '';
          const priceText = document.querySelector('#modalPrice')?.innerText || '';
          const match = priceText.match(/[€$£¥₽₩₹]\s*([\d.,]+)/);
          const originalPrice = match ? parseFloat(match[1].replace(',', '.')) : 0;

          // Skip tracking if offer is greater than or equal to original price
          if (originalPrice > 0 && offerAmount >= originalPrice) {
            console.log('⚠️ Offer greater than or equal to original price, not tracked');
            return;
          }

          const discountPercent = (originalPrice > 0 && offerAmount > 0)
            ? Math.max(0, Math.round(((originalPrice - offerAmount) / originalPrice) * 100))
            : 0;

          const currency = getCurrency('EUR');

          // 1) Push to page dataLayer (for in-page GTM if loaded)
          pushEvent('submit_offer', {
            ecommerce: {
              currency: currency,
              items: [{
                item_name: productTitle,
                price: offerAmount,
                original_price: originalPrice,
                quantity: 1
              }],
              value: offerAmount
            },
            offer_data: {
              customer_name: name,
              customer_email: email.toLowerCase().trim(),
              offer_amount: offerAmount,
              original_price: originalPrice,
              discount_percent: discountPercent
            },
            page_location: window.location.href
          });

          // 2) Publish to Shopify analytics → received by Custom Pixel via subscribe()
          if (window.Shopify?.analytics?.publish) {
            window.Shopify.analytics.publish('submit_offer', {
              customer_name: name,
              customer_email: email.toLowerCase().trim(),
              offer_amount: offerAmount,
              original_price: originalPrice,
              discount_percent: discountPercent,
              product_title: productTitle,
              currency: currency
            });
            console.log('📤 submit_offer published → Custom Pixel');
          } else {
            console.warn('⚠️ Shopify.analytics.publish not available');
          }
        });
      }
    }
  }, 300);
})();